import { styled, Box, BoxProps, css, Checkbox } from '@mui/material'
import Image from '../Image'
import Text from '../Text'

export const OptionsListContainer = styled(Box)<BoxProps>(
  () => css`
    width: 100%;
    padding: 5px 0;
  `
)

export const ProductOptionsRow = styled(Box)<BoxProps>(
  () => css`
    position: relative;
    width: 100%;
    display: flex;
    align-items: center;
    padding: 12px 0;
    gap: 8px;
  `
)

export const Overlay = styled(Box)(
  () => css`
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    top: 0;
    z-index: 2;
    cursor: not-allowed;
    background: rgba(255, 255, 255, 0.6);
  `
)

export const ListCheckbox = styled(Checkbox)(
  () => css`
    margin-left: auto;
    padding: 0;
  `
)

export const ListImage = styled(Image, {
  shouldForwardProp: (prop) => !['alignBaseLine'].includes(String(prop))
})<{
  alignBaseLine: boolean
}>(
  ({ alignBaseLine }) => css`
    align-self: ${alignBaseLine ? 'baseline' : 'auto'};
    min-width: 48px;
  `
)

ListImage.defaultProps = {
  size: 48,
  radius: 4,
  ratio: 90
}

export const NameDescription = styled(Box, {
  shouldForwardProp: (prop) => !['directionRow'].includes(String(prop))
})<
  BoxProps & {
    directionRow: boolean
  }
>(
  ({ directionRow }) => css`
    display: flex;
    flex-direction: ${directionRow ? 'row' : 'column'};
    ${directionRow ? 'gap: 4px;' : ''}
  `
)

export const TitleContainer = styled(Box)<BoxProps>`
  display: flex;
  flex-direction: column;
  gap: 2px;
`

export const Label = styled(Text)`
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: 130%;
`

export const Description = styled(Text)`
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  line-height: 12px;
`
